/** One plural form per count, from the document's plural rules
 *  (internationalization: "Pluralisation is not n === 1"). `{n}` is the localised count. */
export function plural(
  n: number,
  forms: { one: string; other: string },
): string {
  const lang =
    typeof document === 'undefined'
      ? undefined
      : document.documentElement.lang || undefined
  const form =
    new Intl.PluralRules(lang).select(n) === 'one' ? forms.one : forms.other
  return form.replace('{n}', n.toLocaleString(lang))
}
